import React, { memo } from 'react';
import { Box, Tooltip } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { LIST_TABLE_SX } from '../mathTableStyles';
import type { MathColumn } from '../report/mathReportApi';

interface FieldRowProps {
  item: MathColumn;
  canEdit: boolean;
  canDelete: boolean;
  onEdit: (item: MathColumn) => void;
  onDelete: (item: MathColumn) => void;
}

const FieldRow = memo(({ item, canEdit, canDelete, onEdit, onDelete }: FieldRowProps) => (
  <tr>
    <td className="strong">
      <code>{item.field}</code>
    </td>
    <td>{item.headerName}</td>
    <td className="center">
      <span className={item.editable ? 'tag on' : 'tag'}>{item.editable ? 'Да' : 'Нет'}</span>
    </td>
    {(canEdit || canDelete) && (
      <td className="right nowrap">
        {canEdit && (
          <Tooltip title="Редактировать поле" enterDelay={800} arrow>
            <button type="button" className="act icon" aria-label="Редактировать поле" onClick={() => onEdit(item)}>
              <EditOutlinedIcon />
            </button>
          </Tooltip>
        )}
        {canDelete && (
          <Tooltip title="Удалить поле" enterDelay={800} arrow>
            <button type="button" className="act icon danger" aria-label="Удалить поле" onClick={() => onDelete(item)}>
              <DeleteOutlineIcon />
            </button>
          </Tooltip>
        )}
      </td>
    )}
  </tr>
));

interface FieldsTableProps {
  fields: MathColumn[];
  canEdit: boolean;
  canDelete: boolean;
  onEdit: (item: MathColumn) => void;
  onDelete: (item: MathColumn) => void;
}

const FieldsTable: React.FC<FieldsTableProps> = ({ fields, canEdit, canDelete, onEdit, onDelete }) => (
  <Box sx={LIST_TABLE_SX}>
    <table>
      <thead>
        <tr>
          <th>Идентификатор</th>
          <th>Заголовок в таблице</th>
          <th className="center">Редактируемое</th>
          {(canEdit || canDelete) && <th className="right actions">Действия</th>}
        </tr>
      </thead>
      <tbody>
        {fields.map((item) => (
          <FieldRow key={item.field} item={item} canEdit={canEdit} canDelete={canDelete} onEdit={onEdit} onDelete={onDelete} />
        ))}
      </tbody>
    </table>
  </Box>
);

export default memo(FieldsTable);
